import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {  Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BENEFITS_KEY } from 'src/app/components/Price-subscritions/priceplanService';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation, SWAL_WITH_BUTTONS } from 'src/app/services/FormValidation';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { CustomerInteractionComponent } from '../customer-interaction/customer-interaction.component';
import { CustomerJobsComponent } from '../customer-jobs/customer-jobs.component';
import { CUSTOMER_MENU_ITEMS, CustomerService } from '../customer-service.service';
import { CustomerWorkspaceComponent } from '../customer-workspace/customer-workspace.component';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { MtaFilterPipe } from 'src/app/pipe/name-filter.pipe';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-manage-slot',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
MtaFilterPipe
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './manage-slot.component.html',
  styleUrls: ['./manage-slot.component.scss', '../../../../../styles/admin/style.scss','../../../../../styles/admin/app.scss']
})
export class ManageSlotComponent extends FormValidation implements OnInit , OnChanges , OnDestroy {

  @Input() title : string = "";
  @Input('this') superObj : CustomerInteractionComponent | CustomerJobsComponent | CustomerWorkspaceComponent;
  @Input() KEY : BENEFITS_KEY;
  @Input() content : CUSTOMER_MENU_ITEMS;
  @Input() userData : Array<any>  = []; 
  @Input() allocationCards : Array<any>  = []; 
  @Input() planDetails : any = {};
  @Input() editMode : boolean = false;
  @Input() isJobSlot : boolean = false;
  @Output() close = new EventEmitter();
  @Output() onScroll = new EventEmitter();
  @Output() onSucess = new EventEmitter();
  @Output('onSearch') onSearchSlot = new EventEmitter();
  @Output('onAllocate') onAllocation = new EventEmitter();
  @ViewChild("content" , {static :true}) contentModal: TemplateRef<any>
  event : string = '';
  BID: string;
  slotForm ! : FormGroup<any>;
  closeResult: string;
  selectedUsers : Array<any> = [];
  slotPlanExceed: boolean  = false;
  featuredPlanExceed: boolean  = false;
  
  PLANMAX : number;
  ALLOCATED : number;
  AVAILABLE : number;
  TEMPALLOCATED: any;
  TEMPAVAILABLE: any;

  FEATURED_AVAILABLE: number;
  FEATURED_ALLOCATED: number;

  TEMP_FEATURED_AVAILABLE: number;
  TEMP_FEATURED_ALLOCATED: number;
  FEATURED_MAX: number;

  constructor(private modalService : NgbModal , private activatedRoute : ActivatedRoute , private gigsumoService : GigsumoService,
    private util : UtilService ,  private customerService : CustomerService ,  private API : ApiService) {
    super(); 
    this.activatedRoute.parent.data.subscribe(res => {
      this.BID = res.data.id;
    });
  }

  ngOnDestroy(): void {
    this.editMode = false;
    this.handleSlotSubject.unsubscribe();
    this.slotSearchSubject.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const userData =changes.userData && changes.userData.currentValue != null ? changes.userData.currentValue : null;
    const prevuserData =changes.userData && changes.userData.previousValue != null ? changes.userData.previousValue : null;

    if(userData != prevuserData && !changes.userData.firstChange &&  this.event === "SCROLL"){ 
      this.updateExistFormData();
     }
     else if(userData != prevuserData && !changes.userData.firstChange && this.event === "SEARCH"){
      const selected = this.selectedUsers ?? [];  
      this.userData = this.gigsumoService.removeDuplicatesKey([...selected , ...userData] , 'userId');
      console.log("search Happened " , userData , selected);
      
      if(this.slotArray){
        this.slotArray.clear();
        this.updateFormData(true);
      } 
     }

  }

  ngOnInit(): void {
    this.addForm();
    let planArr =  this.planDetails.benefitsUsages;

    if(planArr){
      const arr =  planArr.find(c => c.benefitKey === this.KEY);

      // for jobs posting and featured slots
      if(this.KEY === "JOB_CANDIDATE_POSTINGS"){
         const featured = planArr.find(x => x.benefitKey === "JOBS_CANDIDATE_SPOTLIGHTS");

         this.FEATURED_MAX = +featured.actual;
         this.FEATURED_ALLOCATED = +featured.utilized;
         this.FEATURED_AVAILABLE = +featured.available;
         this.TEMP_FEATURED_ALLOCATED = +featured.utilized;
         this.TEMP_FEATURED_AVAILABLE = +featured.available;
      }

      // for interaction & workspace slots & job slots
      if(arr){
        this.PLANMAX = +arr.actual;
        this.ALLOCATED = +arr.utilized;
        this.AVAILABLE = +arr.available;
        this.TEMPALLOCATED = +arr.utilized;
        this.TEMPAVAILABLE = +arr.available;
      }
    } 
    
    this.onSearch();
    this.updateFormData();
    this.modalService.open(this.contentModal,  { size: 'lg' ,  centered: true , windowClass : "d-block modal show" , backdrop : 'static'});

  }

  updateFormData(isSearch = false){
    if(this.userData){  
      this.userData.forEach(d=>{
        this.pushFields(d);
        if(isSearch && d.value != undefined){
          const userControl = this.slotArray.controls.find(x => x.get('userId').value === d.userId);
          if(userControl){
            userControl.get("slotValue").patchValue(d.value);
          }
        }
      });
    }
  }

  updateExistFormData(data ?: any[]){

    if(this.userData){ 
      this.userData.forEach(d =>{
        const found = this.slotArray.controls.find(x => x.get('userId').value === d.userId);
        if(found){
          return;
        }
       this.pushFields(d);
      }); 
      // this.checkPlanLimitExceeded();
    }
  }

  checkPlanLimitExceeded(){
    const finalVal = this.countArr(this.countMax());

    if (finalVal > this.PLANMAX) {
     setTimeout(() => {
       this.slotArray.setErrors({ slotPlanExceeds: true });
      }, 1000);
   }
  }

  getUpdatedFields<T>(previous: T[], current: T[]): T[] {
    const updatedFields: T[] = [];

    for (let i = 0; i < current.length; i++) {
        if (JSON.stringify(previous[i]) !== JSON.stringify(current[i])) {
            updatedFields.push(current[i]);
        }
    }
    return updatedFields;
  }

  get slotArray() {
    return (this.slotForm && this.slotForm.get('users') as FormArray);
  }

  pushFields({userId , fullName , email  , userType , benefitsUsages , benefitsUsageAndBalance , ...rest} : any){

    // job slot
    if(this.isJobSlot){
      const slotActual  = this.findBenefits(benefitsUsages , "JOB_CANDIDATE_POSTINGS").actual ?? 0;
      const featuredActual  = this.findBenefits(benefitsUsages , "JOBS_CANDIDATE_SPOTLIGHTS").actual ?? 0;

      const fields = new FormGroup({
        checked : new FormControl(rest.checked != undefined ? rest.checked : false),
        superAdmin: new FormControl(rest.isSuperAdmin),
        userId : new FormControl(userId),
        name : new FormControl(fullName),
        email : new FormControl(email),
        userType : new FormControl(userType),

        slotAllocated : new FormControl(slotActual),
        slotValue : new FormControl(slotActual),
        slotUtilized : new FormControl(this.findBenefits(benefitsUsages , "JOB_CANDIDATE_POSTINGS").utilized ?? 0),

        featuredAllocated : new FormControl(featuredActual),
        featuredValue : new FormControl(featuredActual),
        featuredUtilized : new FormControl(this.findBenefits(benefitsUsages , "JOBS_CANDIDATE_SPOTLIGHTS").utilized ?? 0),
      });

      if(rest.checked!= undefined && rest.checked){
        this.modifyFormControl(fields , ['slotValue' , 'featuredValue'] , "enable");
      }
      else{
        this.modifyFormControl(fields , ['slotValue' , 'featuredValue']  , "disable");
      }

      if(this.editMode){
        this.modifyFormControl(fields , ['slotValue' , 'featuredValue']  , "edit");
      }

      this.slotArray.push(fields);
    }
    // interaction slot & workspace slots
    else{
      const slotActual  = this.findBenefits(benefitsUsages , this.KEY).actual ?? 0; 
      console.log(fullName , email);
      
      const fields = new FormGroup({
        checked : new FormControl(rest.checked != undefined ? rest.checked : false),
        superAdmin: new FormControl(rest.isSuperAdmin),
        userId : new FormControl(userId),
        name : new FormControl(fullName),
        email : new FormControl(email), 
        userType : new FormControl(userType), 
        slotAllocated : new FormControl(slotActual),
        slotValue : new FormControl(slotActual),
        slotUtilized : new FormControl(this.findBenefits(benefitsUsages , this.KEY).utilized ?? 0), 
      });
  
      if(rest.checked!= undefined && rest.checked){ 
        this.modifyFormControl(fields , ['slotValue' ] , "enable");
      }
      else{
        this.modifyFormControl(fields , ['slotValue' ]  , "disable");
      }
      
      if(this.editMode){
        this.modifyFormControl(fields , ['slotValue' ]  , "edit"); 
      }
  
      this.slotArray.push(fields); 
    }
    
  }

  modifyFormControl(fields:FormGroup , arr: Array<string> , type: "enable" | "disable" | "edit" = "enable"){
    for(let key of arr) {
      
      if(type === "edit"){
        fields.get(key).enable();
        fields.get(key).setValidators([Validators.required]);
        fields.get(key).updateValueAndValidity();
      }
      else if(type === "enable"){
        fields.get(key).setValidators(Validators.required);
        fields.get(key).enable();
      }
      else{
        fields.get(key).clearValidators();
        fields.get(key).disable();
      }

      fields.get(key).updateValueAndValidity();

    }
  }

  getKeysBasedOnKeys(key : string) : Record<string , string>{
    switch (key) {
      case "SLOT":
        return {
            MAX : "PLANMAX",
            ALLOCATED : "ALLOCATED",
            AVAILABLE : "AVAILABLE",
            TEMPALLOCATED : "TEMPALLOCATED",
            TEMPAVAILABLE : "TEMPAVAILABLE",
            PLANEXCEED :  "slotPlanExceed",  
            utilized : "slotUtilized",
            allocated : "slotAllocated",
            newAllocation : "slotValue",
            cardValue :  "SLOT",  
        };
      case "FEATURED":
        return {
            MAX :  "FEATURED_MAX",
            ALLOCATED : "FEATURED_ALLOCATED",
            AVAILABLE : "FEATURED_AVAILABLE",
            TEMPALLOCATED : "TEMP_FEATURED_ALLOCATED",
            TEMPAVAILABLE : "TEMP_FEATURED_AVAILABLE",
            PLANEXCEED :  "featuredPlanExceed",
            utilized : "featuredUtilized",
            allocated : "featuredAllocated",
            newAllocation : "featuredValue",
            cardValue : "FEATURED"
        };
      default:
        break;
    }

  }

  onSearch() {
    this.handleSlotSubject.subscribe(us =>{

       const {ALLOCATED , MAX , AVAILABLE , TEMPALLOCATED , TEMPAVAILABLE ,
         PLANEXCEED ,  utilized , newAllocation , allocated , cardValue} = this.getKeysBasedOnKeys(us.content);
        console.log(us.content , PLANEXCEED);
        
        const controls =  this.slotArray.controls;
        const values =  this.countSlot(newAllocation , allocated);
        const countedVal = this.countArr(values);
        let allocatedCount = 0;
        let availableCount = 0;
  
        allocatedCount =  this[TEMPALLOCATED] + countedVal;
        if(allocatedCount > this[MAX]){
          this[PLANEXCEED] = true;
          return;
        }
  
        if(controls){
          let find =  controls.find(x => x.get('userId').value === us.userId);
  
          if(find){
            const used =  +find.get(utilized).value;
            const val = +us.value;
  
            if(us.value != '' && val < used){
              find.get(newAllocation).setErrors({lessThanUsed : true});
              return;
            }
            else{
              find.get(newAllocation).removeValidators(this.isLessThanFn());
              find.get(newAllocation).updateValueAndValidity({onlySelf :true});
            }
          }
  
        }
  
        if(this.selectedUsers && !this.editMode){
          const userData = this.selectedUsers.find(x => x.userId === us.userId);
          userData.value = +us.value;
        } 
  
        if(values && values.length > 0){
  
          this[PLANEXCEED] = false;
          availableCount  = this[TEMPAVAILABLE] - countedVal;
  
          this[ALLOCATED] =  allocatedCount;
          this[AVAILABLE] =  availableCount;
  
        }
        else if(values.length === 0){
          this[ALLOCATED] =  this[TEMPALLOCATED];
          this[AVAILABLE] =  this[TEMPAVAILABLE];
        }
 
        this.onAllocation.emit(this.allocationCards.map(x =>{
          // updating only the allocated fields card for jobSlot listing
          if(x.id.includes(cardValue) && !x.id.includes("MAX") && this.KEY === "JOB_CANDIDATE_POSTINGS"){ 
            x.value = this[ALLOCATED];
          }
          // updating allocated and available fields card for interaction and workspace listing
          else if(x.id.includes(cardValue) && this.KEY != "JOB_CANDIDATE_POSTINGS"){
            x.value = x.id.includes("MAX") ? this[AVAILABLE] : this[ALLOCATED];
          }
          return x;
        }));

    });

    this.slotSearchSubject.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
    ).subscribe(r=>{
        this.onSearchSlot.emit(r);
    });
  }  
  
  findBenefits(arr , key : BENEFITS_KEY){
    return arr.find(c => c.benefitKey === key) ?? {
      actual  : 0, utilized : 0
    };
  }

  onCheck(checked : boolean , userId : string , index : number){

    const formControls = this.isJobSlot ? ['slotValue' , 'featuredValue'] : ['slotValue'];

    this.modifyFormControl(this.slotArray.at(index) as FormGroup , formControls , checked ? "enable" : "disable");   

    if(this.slotArray){
      const userData = this.userData.find(c => c.userId === userId) ?? null;   
      userData.checked = checked;   

      this.selectedUsers = this.slotArray.controls.filter(c => c.get('checked').value === true).map(x =>{ 
        const isSelected = this.selectedUsers.find(d => d.userId === x.get("userId").value) ?? null;
        const data = isSelected ? isSelected : userData;
        return {
          ...data , ...x.getRawValue()
        }
      });  
    }
  }

  handleSlotSubject = new Subject<any>();
  handleFeaturedSubject = new Subject<any>();
  handlePostingSubject = new Subject<any>();
  slotSearchSubject = new Subject<any>();

  onChange(userId , event, index , content = "SLOT"){
     this.handleSlotSubject.next({userId : userId , value : event.target.value , index : index , content : content});
  } 

  isAnyoneChecked() {
    return this.slotArray.controls.some(x => x.get('checked').value === true);
  }

  isLessThanFn() : ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return {lessThanUsed : true}
    }
  } 

  countSlot(param1 , param2){
    if(this.slotArray.controls){
        return this.slotArray.controls.map(f=> f.get(param1).getRawValue() - f.get(param2).getRawValue())
        .filter(c => c!= undefined);
    }
  }

  countMax(){
    if(this.slotArray.controls){
        return this.slotArray.controls.map(f=> +f.get('value').getRawValue())
        .filter(c => c!= undefined);
    }
  }

  addForm(){
    this.slotForm = new FormGroup({
      users : new FormArray([])
    });
  }

  closeModal(){
    this.modalService.dismissAll();
    this.close.emit("CLOSE")
  }

  filterCheckedUser() : Array<any>{
    const con = this.slotArray.controls;
    if(con){
      let  d = con.map(x => {
        if(x.get('checked').value === true){
          return {
            userId : x.get('userId').value,
            value : x.get('value').value
          };
        }
      }).filter(x => x!= undefined);
       return d;
    }
  }

  getManagePayload(slotArray : Array<any>) : Record<string , Array<any>> {
    if(slotArray){
        return this.isJobSlot ?
        {
          "JOB_CANDIDATE_POSTINGS": slotArray.map(user => ({ userId: user.userId, value: +user.slotValue })),
          "JOBS_CANDIDATE_SPOTLIGHTS": slotArray.map(user => ({ userId: user.userId, value: +user.featuredValue }))
        } :
        {
          [this.KEY] : slotArray.map(user => ({ userId: user.userId, value: +user.slotValue })),
        }
        ;
     }

     return {}
  }

  manageSlot(){
      let payload = this.getManagePayload(this.editMode ? this.slotArray.getRawValue() : this.slotArray.getRawValue().filter(x => x.checked));
      console.log(payload);   
      // let data  = this.editMode ?  this.slotArray.getRawValue().map(x =>{
      //   return {userId : x.userId , value : x.value};
      //  }) : this.filterCheckedUser(); 

       if(this.slotForm.valid && !this.slotPlanExceed){
        this.util.startLoader();
        this.API.create(`subscription/manageMultipleBenefitsSlotsAllocation?businessId=${this.BID}`,   payload).
        subscribe({
          next : (res) => this.updateResponse(res),
        });
       }


  }

  updateResponse(response){
      if(response.code === AppSettings.SUCESS_CODE){
          this.onSucess.emit("SUCCESS");
          this.modalService.dismissAll();
          this.util.stopLoader();
          setTimeout(() => {
            this.customerService.emitRefresh(this.content);
          }, 1500);
          Swal.fire({
            icon: "success",
            title: "Slots Allocated",
            text: "Slots has been allocated Sucessfully",
            showConfirmButton: false,
            timer: 2000,
          });
      }
      else if(response.code === "99997"){
        this.slotPlanExceed = true;
      }
      else if(response.code === "99996"){
        const userID = response.data.userAffected.userId;
        const controls = this.slotArray.controls.find(x => x.get('userId').value === userID);
        if(controls){
          controls.get('value').setErrors({lessThanUsed : true});
        }
      }

      this.util.stopLoader();
  }

  onScrollDown(){
    if(!this.superObj.stopScroll){
      this.event = "SCROLL";
      this.onScroll.emit("SCROLL");
    }
  }

  onSlotSearch(v){
    this.event = "SEARCH";
    this.slotSearchSubject.next(v);
  } 


  distributeEqually(){
    SWAL_WITH_BUTTONS.fire({
      icon : "warning",
      title : "Distribute Equally",
      text : "You selected Distribute Equally. By clicking Yes, it will be allocated.",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: true,
    }).then(x  => {

      let data = {
        benefitKey: this.KEY,
        businessId: this.superObj.businessData.id
      };

      if(x.isConfirmed){
        this.util.startLoader();

        this.API.create("subscription/allocateBEnefitsEqually" , data).subscribe({
          next: (res) => {
            if(res.code === GigsumoConstants.SUCESSCODE){
              Swal.fire({
                icon: "success",
                title: "Slots Allocated",
                text: "Slots has been allocated Sucessfully",
                showConfirmButton: false,
                timer: 2000,
              });

              this.close.emit("SUCESS");
              this.modalService.dismissAll();
              setTimeout(() => {
                this.customerService.emitRefresh(this.content);
              }, 1500);

            }
            else if(res.code === "99998"){
              Swal.fire({
                icon : "error",
                title : "Insufficient Allocation",
                text : "Allocation cannot be equally distributed due to insufficient allocations",
                allowOutsideClick : false
               });
            }

            setTimeout(() => {
              this.util.stopLoader();
            }, 1000);
          },
          error: (err) =>{
            this.util.stopLoader();
          }
        })

      }


    });
  }


  isPlanExceed() {
    return (this.slotPlanExceed || this.featuredPlanExceed)
  }


  toggleCheckbox(index: number) {
    const control = this.slotArray.at(index).get('checked');
    const newValue = !control.value;
  
    control.setValue(newValue);
  
    const userId = this.slotArray.at(index).get('userId').value;
  
    this.onCheck(newValue, userId, index);
  }

}
